import $ from "jquery";
import Cookies from "js-cookie";
import { apiEndpoint, apiDevEndpoint } from "constants";

const currentEndpoint = "https://api.storex.io";

export function fetchProposals(user) {
    if (!user) return Promise.reject("user: Undefined");

    return $.ajax({
        type: "GET",
        url: currentEndpoint + "/V1/governance/proposals",
        xhrFields: {
            withCredentials: true
        },
        data: {
            user: user
        },
        error: function(res) {
            if (res.status === 0) return $("div.modal").addClass("error").find("div.text").html("There was an error processing your request, please try again");

            var { message } = res.responseJSON || { message: res };

            $("div.modal").addClass("error").find("div.text").html(message);
        }
    });
};

export function createProposal(user) {
    if (!user) return Promise.reject("user: Undefined");

    return $.ajax({
        type: "POST",
        url: currentEndpoint + "/V1/governance/proposal/create",
        xhrFields: {
            withCredentials: true
        },
        data: {
            user: user,
            duration: 2678400,
            title: "The Next Chapter",
            description: "Earlier in the year we announced our plan to launch a brand new e-commerce marketplace on the Solana network, named SolBay. This announcement was met with concern from the community regarding the future of the Storex (STRX) token. After months of debate within the community, we have curated a list of options that align with our vision for cross-chain e-commerce while also incorporating feedback and opinions from the community. The new marketplace on Solana will be launched regardless of the outcome of this vote. This vote will decide how intertwined the new marketplace on Solana will be with Storex on XPR Network.",
            options: JSON.stringify([
                { subtitle: "Proposed Roadmap 1", description: "The basis of this proposed roadmap is to have the Storex marketplace continue on XPR Network and the SolBay marketplace to launch on Solana. Both marketplaces would be completely separate and both would be powered by their own respective token. Inflation would need to be introduced to the Storex (STRX) token to maintain staking rewards, yield farming rewards, and cashback incentives.</br></br><a href='https://storex.medium.com/proposed-roadmap-1-f3dc1f7a886e' target='_blank'>Read more</a>" },
                { subtitle: "Proposed Roadmap 2", description: "The basis of this proposed roadmap is to have the Storex marketplace operate on both XPR Network and Solana. The same branding will represent both marketplaces cross-chain. A shared database of listings and users will exist on both networks, with the addition of cross-chain payment reconciliation available for most payment methods. A new cross-chain token (name TBD) will be created to replace the existing Storex (STRX) token and to replace the need for the SolBay (SOLBAY) token. This single unified token will power both marketplaces and both networks.</br></br><a href='https://storex.medium.com/proposed-roadmap-2-2fcd83054455' target='_blank'>Read more</a>" },
                { subtitle: "Proposed Roadmap 3", description: "The basis of this proposed roadmap is to have the Storex marketplace continue on XPR Network and the SolBay marketplace to launch on Solana. A new cross-chain token (name TBD) will be created to replace the existing Storex (STRX) token and to replace the need for the SolBay (SOLBAY) token. This single unified token will power both marketplaces and both networks.</br></br><a href='https://storex.medium.com/proposed-roadmap-3-d9394e5fa03e' target='_blank'>Read more</a>" }
            ])
        },
        error: function(res) {
            if (res.status === 0) return $("div.modal").addClass("error").find("div.text").html("There was an error processing your request, please try again");

            var { message } = res.responseJSON || { message: res };

            $("div.modal").addClass("error").find("div.text").html(message);
        }
    });
};

export function voteProposal(user, proposalId, optionId) {
    if (!user) return Promise.reject("user: Undefined");
    if (proposalId == null) return Promise.reject("proposalId: Undefined");
    if (optionId == null) return Promise.reject("optionId: Undefined");

    return $.ajax({
        type: "POST",
        url: currentEndpoint + "/V1/governance/proposal/vote",
        xhrFields: {
            withCredentials: true
        },
        data: {
            user: user,
            proposalId: proposalId,
            optionId: optionId
        },
        error: function(res) {
            if (res.status === 0) return $("div.modal").addClass("error").find("div.text").html("There was an error processing your request, please try again");

            var { message } = res.responseJSON || { message: res };

            $("div.modal").addClass("error").find("div.text").html(message);
        }
    });
};